/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `ar` - AR
 * * `font` - Font
 * * `image` - Image
 * * `pdf` - PDF
 * * `video` - Video
 * * `web` - Web
 */
export enum FileContentTypeEnum {
    AR = 'ar',
    FONT = 'font',
    IMAGE = 'image',
    PDF = 'pdf',
    VIDEO = 'video',
    WEB = 'web',
}
